export const playerMediaInteractionEvent = "qassist:player-media-interaction";

export function requestPlayerMediaInteraction(): void {
  window.dispatchEvent(new Event(playerMediaInteractionEvent));
}

export function enableYoutubeSound(
  target: { postMessage(message: string, targetOrigin: string): void } | null | undefined,
): void {
  target?.postMessage(JSON.stringify({ event: "command", func: "unMute", args: [] }), "*");
  target?.postMessage(JSON.stringify({ event: "command", func: "playVideo", args: [] }), "*");
}

export function startYoutubeShuffle(
  target: { postMessage(message: string, targetOrigin: string): void } | null | undefined,
  initialIndex?: number,
): void {
  if (initialIndex !== undefined)
    target?.postMessage(
      JSON.stringify({ event: "command", func: "playVideoAt", args: [initialIndex] }),
      "*",
    );
  target?.postMessage(JSON.stringify({ event: "command", func: "setShuffle", args: [true] }), "*");
}

export function youtubePlaylistStartIndex(shuffle: boolean): number | undefined {
  return shuffle ? 1 : undefined;
}

export function rotateYoutubeListForInitialSkip(ids: string[], shuffle: boolean): string[] {
  return shuffle && ids.length > 1 ? [...ids.slice(1), ids[0]!] : [...ids];
}
